import { Tab, Tabs } from '@material-ui/core';
import React, { useState } from 'react';
import { useObservable } from 'react-use-observable';
import { ECancelTabs } from 'v2/interfaces/reports/cancel';
import { cancelService } from 'v2/services/reports/cancel';

import Breadcrumbs from '../Breadcrumbs';
import ChartTab from './ChartTab';
import Filter from './Filter';
import { useStyles } from './styles';

function Cancel() {
  useObservable(() => cancelService.loadData(ECancelTabs.CANCEL), []);

  const classes = useStyles();
  const [tab, setTab] = useState<string>(ECancelTabs.CANCEL);

  const handleChange = (_: React.ChangeEvent<{}>, newTab: string) => setTab(newTab);

  const breadcrumbsLink = [
    {
      url: '/producer/reports/sales',
      name: 'Relatórios',
    },
  ];

  return (
    <>
      <Breadcrumbs navList={breadcrumbsLink} currentPage='Motivos de Cancelamento' />

      <h1 className={classes.title}>Motivos de Cancelamento</h1>

      <Tabs className={classes.tabs} onChange={handleChange} value={tab} indicatorColor='primary' textColor='primary'>
        <Tab className={classes.tab} value={ECancelTabs.CANCEL} label='Cancelamentos' />
      </Tabs>

      <Filter />

      {tab === ECancelTabs.CANCEL ? <ChartTab /> : <>Statistics</>}
    </>
  );
}

export default Cancel;
